import * as styles from './SalaryBands.module.scss'

const SalaryBands = ({ salaryBands }) => (
  <div className={styles.tableContainer}>
    <table>
      <thead>
        <tr>
          <th className={styles.tableBorderRadiusLeft}>Level</th>
          <th>Position Within Level</th>
          <th className={styles.tableBorderRadiusRight}>Salary</th>
        </tr>
      </thead>
      <tbody>
        {salaryBands.map((salary, index) => (
          <tr key={index}>
            <td data-table-data-label="Level">{salary.level}</td>
            <td data-table-data-label="Position">{salary.position}</td>
            <td style={{ fontWeight: 'bold' }} data-table-data-label="Salary">
              {salary.salary}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)
export default SalaryBands
